<h2 class="mb-5" *ngIf="action == 'EDIT'">{{'IDEALPROFILE.EDIT' |translate}}</h2>
<h2 class="mb-5" *ngIf="action == 'DETAIL'">{{'IDEALPROFILE.DETAIL' |translate}}</h2>
<h2 class="mb-5" *ngIf="action == 'CREATE'">{{'IDEALPROFILE.CREATE' |translate}}</h2>


<div class="row mb-4">
    <div class="col-6">
        <div class="btn btn-primary backToProfilesButton" (click)="utilsService.goBack();">
            <i class="fa fa-arrow-left" style="font-size: 15px;"></i> {{ ('COMMON.BACK' | translate).toUpperCase() }}
        </div>
    </div>
</div>

<form [formGroup]="editProfileForm" (ngSubmit)="onSubmit()" id="editProfileForm">
    <div class="row">
        <div class="col-6">
            <div class="card mb-4 border-0 shadow-sm" *ngIf="projects.length > 0">
                <div class="card-header border-bottom-0">{{'COMMON.PROJECT' |translate}}</div>
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group col-12">
                            <label for="project">{{'IDEALPROFILE.NAME' |translate}}:</label>
                            <select name="project" class="form-control" formControlName="project" (change)="getClientSkills()">
                              <option value=null selected>Por defecto</option>
                              <ng-container *ngFor="let parentProject of projects">
                                <option *ngFor="let project of parentProject.children" [value]="project.id">
                                  {{ project.name + (project.description ?  ' - ' + project.description : '') }}
                                </option>
                              </ng-container>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-4 border-0 shadow-sm">
                <div class="card-header border-bottom-0">{{'IDEALPROFILE.PROFILE' |translate}}</div>
                <div class="card-body">
                    <div class="form-row">
                        <div class="form-group col-12">
                            <label for="name">{{'IDEALPROFILE.NAME' |translate}}: *</label>
                            <input type="name" class="form-control" id="name" formControlName="name">
                            <ct-control-messages [control]="editProfileForm.get('name')"></ct-control-messages>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12">
                            <label for="description">{{'IDEALPROFILE.DESCRIPTION' |translate}}</label>
                            <textarea type="description" class="form-control" id="description" formControlName="description" cols="30" rows="3">
                </textarea>
                            <ct-control-messages [control]="editProfileForm.get('description')"></ct-control-messages>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="card mb-4 border-0 shadow-sm">
                <div class="card-header border-bottom-0">{{'IDEALPROFILE.ASOCIATEDCOMPETENCES' |translate}}</div>
                <div class="card-body">
                    <div class="form-group col-12">
                        <div class="form-row mb-4">
                            <div class="form-group col-12">
                                <label for="jobtype">{{'IDEALPROFILE.ASOCIATEDJOBTYPE' |translate}}: *</label>
                                <div>
                                    <select class="form-control" id="jobtype" formControlName="jobtype" *ngIf="this.action !== 'CREATE'">
                                      <option *ngFor="let jobtype of jobtypes$ | async" [ngValue]="jobtype.id">{{ jobtype.name |titlecase }}</option>
                                    </select>
                                </div>
                                <div>
                                    <select class="form-control" id="jobtype" formControlName="jobtype" *ngIf="this.action === 'CREATE'" (change)="setJobtypeSelected()">
                                      <option [ngValue]="null" hidden>{{ 'INVITE.SELECTJOBTYPE' | translate }}</option>
                                      <option *ngFor="let jobtype of jobtypes$ | async" [ngValue]="jobtype.id">{{ jobtype.name |titlecase }}</option>
                                    </select>
                                </div>
                                <ct-control-messages [control]="editProfileForm.get('jobtype')"></ct-control-messages>
                            </div>
                        </div>
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>{{'IDEALPROFILE.AREA' |translate}}</th>
                                    <th>{{'IDEALPROFILE.COMPETENCE' |translate}}</th>
                                    <th>{{'IDEALPROFILE.MIN' |translate}}</th>
                                    <th>{{'IDEALPROFILE.MAX' |translate}}</th>
                                </tr>
                            </thead>

                            <tbody class="bg-white">
                              <ng-container *ngIf="jobtypeSelected; else jobtypeNotSelected">
                                <tr *ngFor="let questionGroup of jobtypeSelected.questionGroups; index as i">
                                  <td>{{ 'ADNREPORT.SKILLS.TYPES.' + questionGroup.type.toUpperCase() | translate }}</td>
                                  <td>{{ 'ADNREPORT.SKILLS.' + questionGroup.abbreviation + '.NAME' | translate }} </td>
                                  <td><input class="form-control input-edit" type="number" [attr.disabled]="this.action == 'DETAIL' ? true : null" [id]="questionGroup.abbreviation.toLowerCase() + '_minValue'" min="0" max="9" (input)="valueCheck($event.target)"></td>
                                  <td><input class="form-control" type="number" disabled value="10"  min="10" max="10"></td>
                                </tr>
                              </ng-container>
                              <ng-template #jobtypeNotSelected>
                                  <ng-container *ngIf="profileSelected; else profileNotSelected">
                                      <tr *ngFor="let questionGroup of profileSelected.jobtype.questionGroups; index as i">
                                        <td>{{ 'ADNREPORT.SKILLS.TYPES.' + questionGroup.type.toUpperCase() | translate }}</td>
                                        <td>{{ ('ADNREPORT.SKILLS.' + questionGroup.abbreviation + '.NAME') | translate }} </td>
                                        <td><input class="form-control input-edit" type="number" [attr.disabled]="this.action=='DETAIL'? true: null" [value]="profileSelected.adnIdeal[questionGroup.abbreviation.toLowerCase()]" [id]="questionGroup.abbreviation.toLowerCase() + '_minValue'" min="0" max="9" (input)="valueCheck($event.target)"></td>
                                        <td><input class="form-control" type="number" disabled value="10"  min="10" max="10"></td>
                                      </tr>
                                  </ng-container>
                                  <ng-template #profileNotSelected>
                                    <tr>
                                        <td class="text-center" colspan="4">{{'IDEALPROFILE.JOBTYPESELECT' |translate}}</td>
                                    </tr>
                                  </ng-template>
                              </ng-template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<div class="row" *ngIf="action !== 'DETAIL'">
    <button type="submit" form="editProfileForm" class="btn btn-primary form-control col-md-2 mx-auto mb-4" [disabled]="editProfileForm.invalid">
    <i class="fa fa-save"></i> {{ 'COMMON.SAVE' | translate }}
  </button>
</div>
